import script from "./comp_lista_restaurantes.vue?vue&type=script&setup=true&lang=js"
export * from "./comp_lista_restaurantes.vue?vue&type=script&setup=true&lang=js"

import "./comp_lista_restaurantes.vue?vue&type=style&index=0&id=1d2773f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2773f2"]])

export default __exports__